import React, { Component } from 'react'

import { Button, Typography, message, Modal, Checkbox } from 'antd';

import request from 'request'

import styles from './style.scss'

const { Title } = Typography;

class PayConfirm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: false,
      visible: true,
      hyBeanNum: 0,
      loading: false,
    }

    this.payTypeList = [];

    this.taskTimer = null;

    this.handleCancel = this.handleCancel.bind(this)
    this.handleOk = this.handleOk.bind(this)
  }

  componentDidMount() {
    this.getPayTypeDetail();
    this.getUserHuyaCoinBalance();
  }

  handleCancel() {
    this.props.closeConfirm();

    clearInterval(this.taskTimer);
  }

  handleOk() {
    this.startPay();
  }

  startPay() {
    const {info} = this.props;
    const {orderId, extUuid} = info;

    const payType = this.payTypeList[0];

    this.setState({
      loading: true,
    })

    request({
      url: request.api.payServiceExtFee,
      type: 'POST',
      data: {
        orderId,
        paySource: 'web',
        channel: payType,
      },
    })
      .done(res => {
        this.startGetPayStatus(orderId, extUuid);
      })
      .fail(err => {
        message.warn(err);

        this.setState({
          loading: false,
        })
      })
  }

  startGetPayStatus(orderId, extUuid) {
    const startTime = Date.now();
    const timeoutTime = 10 * 1000;

    const requestStatus = cb => {
      request({
        url: request.api.detectIsBuySuccessful,
        data: {
          orderId,
          extUuid,
        },
      })
        .done(res => {
          // true 为支付成功, false 继续查询
          const isSuccess = res
          cb(isSuccess);
        })
        .fail(err => {
          const isSuccess = false;
          cb(isSuccess, err || '未知错误');
        })
    }

    this.taskTimer = setInterval(() => {
      if (Date.now() - startTime >= timeoutTime) {
        clearInterval(this.taskTimer);

        this.setState({
          loading: false,
        })

        message.warn('支付失败，请重新尝试');
        return;
      }

      requestStatus((isSuccess, err = '') => {
        if (isSuccess) {
          clearInterval(this.taskTimer);

          this.props.paySuccess();
        }

        // 请求失败
        if (err) {
          clearInterval(this.taskTimer);

          this.setState({
            loading: false,
          })
          message.warn(err);
        } else {
          if (isSuccess) { // 补缴成功, 停止轮询
            clearInterval(this.taskTimer);

            this.setState({
              loading: false,
            })

            this.props.paySuccess();

          } else { // 补缴还未成功, 继续
            // continue
          }
        }
      });
    }, 1000)
  }

  getPayTypeDetail(extUuid) {
    const url = request.api.getExtExpenseAttr + `?extUuid=${extUuid}`;

    request({
      url,
      type: 'GET',
    })
      .done(res => {
        this.payTypeList = res;
      })
      .fail(err => {

      })
  }

  getUserHuyaCoinBalance() {
    request({
      type: 'GET',
      url: request.api.getHuyaCoinBalance,
    })
      .done(res => {
        this.setState({
          hyBeanNum: res,
        })
      })
      .fail(err => {

      })
  }

  render() {
    const { visible, loading, hyBeanNum} = this.state;
    const { info } = this.props;

    const okBtnText = loading ? '支付中，请稍后' : '立即支付';

    return (
      <div>
        <Modal
          title="补缴费用"
          visible={visible}
          centered = {true}
          width={480}
          mask = {true}
          onCancel={this.handleCancel}
          footer={[
            <Button key="back" onClick={this.handleCancel}>
                          取消
            </Button>,
            <Button key="submit" type="primary" loading={loading} onClick={this.handleOk}>
              {okBtnText}
            </Button>,
          ]}
        >

          <div className={styles.confirm}>
            <p>是否立即支付<strong style={{fontSize: 20}}>{info.extName}</strong>小程序在<strong style={{fontSize: 20}}>{info.time}</strong>产生的费用？</p>
            <p>共计<strong style={{fontSize: 22}}>{info.fee / 100}</strong>元</p>

            <p>支付方式：虎牙币支付（剩余{hyBeanNum}）,<a href="https://zhifu.huya.com/web/pay_hy_coin.html" target="_blank"> 立即充值</a></p>
          </div>
        </Modal>
      </div>
    )
  }
}

export default PayConfirm;
